import { useDispatch, useSelector } from "react-redux"
import { getPartnerGenderIdentity } from "../../../../reducers/userInfo"
import { useToggle } from "../../../../utils/Hooks"
import { updatePartnerGenderIdentity } from "../../../../actions/userActions"
import { FleLayout } from "../FleLayout"
import { BackArrow, SkipArrow, SwitchH2ToBodyLarge } from "../Molecules"
import { FleLinkWrapper, InfoCircle } from "../../atoms/Links"
import { Spacer } from "../../atoms/Atoms"
import GenderIdentityChoices from "../../../../content/GenderIdentityChoices"
import { Button } from "../../atoms/buttons/Button"
import FLEInformationModal from "components/views/modal/FLEInformationModal"
import React from "react"
import L10n from "../../../../lib/carrot-l10n"
import { TopSection } from "../TopSection"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const AboutYourPartnerGenderIdentity = ({ next, history }) => {
  const partnerGenderIdentity = useSelector((state) => getPartnerGenderIdentity(state))
  const dispatch = useDispatch()
  const [showPartnerGenderIdentityModal, togglePartnerGenderIdentityModal] = useToggle(false)
  const submitPartnerGenderIdentity = async (genderIdentity) => {
    await dispatch(updatePartnerGenderIdentity(genderIdentity, null))
    history.push(next)
  }
  return (
    <FleLayout>
      <TopSection progressStep={3} leftOrBackArrow={<BackArrow />} />
      <div className="flex flex-row items-center">
        <SwitchH2ToBodyLarge>{`What’s your partner’s gender identity?`}</SwitchH2ToBodyLarge>
        <InfoCircle onClick={togglePartnerGenderIdentityModal} />
      </div>
      <Spacer height={3} />
      {GenderIdentityChoices.map(({ id, label }) => (
        <div key={id} className="flex flex-row justify-end w-100 mb1">
          <Button outline={id === partnerGenderIdentity} bold={false} onClick={() => submitPartnerGenderIdentity(id)}>
            {label}
          </Button>
        </div>
      ))}
      <FleLinkWrapper>
        <SkipArrow to={next} />
      </FleLinkWrapper>
      {showPartnerGenderIdentityModal ? (
        <FLEInformationModal
          onClose={togglePartnerGenderIdentityModal}
          header={l`fle2.aboutyourpartner.genderidentity`}
          source={l`fle2.partnerGenderIdentityFull`}
        />
      ) : null}
    </FleLayout>
  )
}

export { AboutYourPartnerGenderIdentity }
